import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import cx from 'classnames';

import {
  nextTourStep,
  finishWelcomeTour,
} from 'redux/reducers/onboardingSlice';
import { TourStepEnum } from 'features/onboarding/enums';
import { useAppDispatch } from 'hooks/useAppDispatch';

import styles from './TourStep.module.less';

type Props = {
  className?: string;
  icon?: React.ReactNode;
  stepType: TourStepEnum;
  isLastStep?: boolean;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
};

export default function TourStep(props: Props) {
  const {
    icon,
    title,
    stepType,
    className,
    description,
    isLastStep = false,
  } = props;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleNextStep = () => {
    dispatch(nextTourStep(stepType));
  };

  const handleCloseWelcomeTour = () => {
    dispatch(finishWelcomeTour());
    navigate('/company-profile');
  };

  return (
    <div className={cx(className, styles.tourStep)}>
      {icon && icon}

      <h3 className={styles.tourTitle}>{title}</h3>

      <div className={styles.tourDesc}>{description}</div>

      <div className={styles.tourBtnBox}>
        {!isLastStep ? (
          <Button type="primary" onClick={handleNextStep}>
            Next
          </Button>
        ) : (
          <Button type="primary" onClick={handleCloseWelcomeTour}>
            Let's Go
          </Button>
        )}
      </div>
    </div>
  );
}
